import { CModalBody } from "@coreui/react";
import React from "react";

const PostValidation = () => {
  return (
    <CModalBody className="text-justify">
      <p>
        Now you can start looking at your next actions to see how to improve you
        scores.
      </p>
      <p>
        We recommend annual re-validation - or more frequently if you feel you
        have achieved progress and want to disclose an increased score.
      </p>
    </CModalBody>
  );
};

export default PostValidation;
